import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'

interface EventLimitInterface {
  limitReached: boolean
}

export const useEventLimitReached = () => {
  const { user } = useUser()

  const { fetcher, isFetching: isFetchingEventLimit } = useFetch<
    RequestMethodsEnum.get,
    EventLimitInterface
  >({ method: RequestMethodsEnum.get })

  const { data: eventLimit } = useControlledSwr(
    () =>
      user && [
        `/api/dashboard/booking-calendar/user-plan/event-limit-reached`,
        RequestModuleEnum.Calendar,
      ],
    fetcher,
  )

  return { eventLimit, isFetchingEventLimit }
}
